import { gql } from '@apollo/client';

export const getAgendaUser = gql/* GraphQL */ `
query GetAgendaUser($userId: ID!) {
    getAgendaUser(userId: $userId) {
      comId
      email
      image
      isConfirmed
      role
      suspended
      type
      FCMtoken
      userId
      username
      firstName
      lastName
      monday
      tuesday
      thursday
      wednesday
      friday
      saturday
      sunday
      night
      hours
      readedAt
      __typename
      com {
        account_type
        address
        comId
        createdAt
        customer_id
        name
        phoneNumber
        planId
        image
        subscriptionId
        suspended
        type
        updatedAt
        userId
        __typename
      }
    }
  }
  `;